import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ProjectTypeSelector } from "../ProjectTypeSelector";
import { AIContentGenerator } from "./AIContentGenerator";
import { FeaturePointsInput } from "./FeaturePointsInput";

interface ProjectFormInputsProps {
  projectData: {
    title: string;
    client: string;
    types: string[];
    link: string;
    featurePoints?: string[];
  };
  setProjectData: (data: any) => void;
  handleImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleTypeToggle: (type: string) => void;
}

export const ProjectFormInputs = ({
  projectData,
  setProjectData,
  handleImageChange,
  handleTypeToggle,
}: ProjectFormInputsProps) => {
  const handleAIGeneration = (data: any) => {
    setProjectData({
      ...projectData,
      title: data.title || projectData.title,
      client: data.description || projectData.client,
      featurePoints: [...(projectData.featurePoints || []), ...(data.features || [])],
    });
  };

  return (
    <div className="space-y-6">
      <AIContentGenerator onContentGenerated={handleAIGeneration} />

      <div className="space-y-2">
        <Label htmlFor="title" className="text-gray-200">Blog Title</Label>
        <Input
          id="title"
          value={projectData.title}
          onChange={(e) => setProjectData({ ...projectData, title: e.target.value })}
          required
          className="bg-black/30 border-gray-800 text-white placeholder-gray-500"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="client" className="text-gray-200">Subtext</Label>
        <Input
          id="client"
          value={projectData.client}
          onChange={(e) => setProjectData({ ...projectData, client: e.target.value })}
          required
          className="bg-black/30 border-gray-800 text-white placeholder-gray-500"
        />
      </div>

      <ProjectTypeSelector
        selectedTypes={projectData.types}
        onTypeToggle={handleTypeToggle}
      />

      <div className="space-y-2">
        <Label htmlFor="image" className="text-gray-200">Upload Image</Label>
        <Input
          id="image"
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          required
          className="bg-black/30 border-gray-800 text-white file:bg-gray-800 file:text-white file:border-0"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="link" className="text-gray-200">Links</Label>
        <Input
          id="link"
          type="url"
          value={projectData.link}
          onChange={(e) => setProjectData({ ...projectData, link: e.target.value })}
          placeholder="https://"
          className="bg-black/30 border-gray-800 text-white placeholder-gray-500"
        />
      </div>

      <FeaturePointsInput
        featurePoints={projectData.featurePoints || []}
        onChange={(points) => setProjectData({ ...projectData, featurePoints: points })}
      />
    </div>
  );
};